export const errorCodeMap = {
  10001: "额度已用完",
} as Record<number, string>;
